import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useUpdateCategoryMutation, useLazyGetCategoryByIdQuery } from '@modules/category';

import { editCategorySchema } from './data';
import { EditCategorySate, IUpdateCategoryFormData } from './types';
import {
  getCategoryData,
} from './logicHelper';

export const useEditCategoryLogic = () => {
  const { categoryId = '' } = useParams()
  const [getCategoryById] = useLazyGetCategoryByIdQuery();
  const [updateCategoryById] = useUpdateCategoryMutation();

  const [state, setState] = useState<EditCategorySate>({
    isSuccess: '',
    isLoading: true,
    isDeleteModalOpen: false,
  })

  const methods = useForm<IUpdateCategoryFormData>({
    // @ts-ignore
    resolver: yupResolver(editCategorySchema),
    mode: 'onSubmit',
    defaultValues: {}
  });

  const {
    reset,
    watch,
    register,
    setValue,
    setError,
    handleSubmit,
    formState: { errors }
  } = methods

  const onSubmit = async (data: IUpdateCategoryFormData) => {
    setState((prev) => ({ ...prev, isSuccess: '', isLoading: true }));

    try {
      await updateCategoryById({ formData: data, id: categoryId }).unwrap();

      getCategoryData({ reset, categoryId, setState, getCategoryById });
      setState((prev) => ({ ...prev, isSuccess: 'Category has been successfully updated' }));
    } catch (error) {
      console.log('Error: ', error);
      setState((prev) => ({
        ...prev,
        isLoading: false,
        isSuccess: 'Something went wrong'
      }));
    }
  };

  useEffect(() => {
    if (!categoryId) {
      return;
    }

    getCategoryData({ reset, categoryId, setState, getCategoryById });
  }, [])

  return {
    ...state,
    methods,
    errors,
    setState,
    onSubmit,
    register,
    handleSubmit,
    getCategoryData: () => getCategoryData({ reset, categoryId, setState, getCategoryById }),
  }
}
